import { SelectLocation } from "./SelectLocation.js";
import { SelectSubLocation } from "./SelectSubLocation.js";
import { useState } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { useUpdateEffect } from "ahooks";
//#region src/modules/Locations/shared/SelectLocationAndSubLocation.tsx
function SelectLocationAndSubLocation(props) {
	const [location, setLocation] = useState();
	useUpdateEffect(() => {
		if (!location) props.onChangeSubLocationValue?.(null);
	}, [location]);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(SelectLocation, {
		...props,
		multi: false,
		onChangeValue: (value) => {
			props?.onChangeValue?.(value);
			if (!value || !value.length) props.onChangeSubLocationValue?.(null);
		},
		onLocationValue: (locations) => {
			setLocation(locations[0]);
		}
	}), !!location?.subLocations && /* @__PURE__ */ jsx(SelectSubLocation, {
		isClearable: true,
		label: "Sub Location",
		onChangeValue: (value) => {
			props.onChangeSubLocationValue?.(value);
		},
		parentLocationId: location.id,
		value: props.subLocationValue
	})] });
}
//#endregion
export { SelectLocationAndSubLocation };

//# sourceMappingURL=SelectLocationAndSubLocation.js.map